import { render, staticRenderFns } from "./CamaraAlertaPantalla.vue?vue&type=template&id=6c525826&scoped=true&"
import script from "./CamaraAlertaPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraAlertaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c525826",
  null
  
)

export default component.exports